<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Hcyzgg/tc-custom/9781621381464.jpg?1685327484714" alt="This image is the cover for the book The Case for Catholic Education"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Case for Catholic Education
      </h1>
      <p class="bookDescription body article font2">
        <p>Catholic schools have long contributed to the mission of the Church and to the flourishing of society. During the past few decades, however, Catholic schools have suffered severe losses, both in their religious identity and in their capacity to attract students. With penetrating insights, pointed anecdotes, and drawing upon recent empirical studies and Church documents, Ryan Topping describes the near collapse of Catholic education in North America and uncovers the enduring principles of authentic renewal. In The Case for Catholic Education you'll discover: · the three purposes of Catholic education · why virtue is more important than self-esteem · the elements of a true "common core" curriculum · essential differences between "progressive" and "Catholic" models of learning · helpful study questions and a research guide "This is an accessible and eminently readable book on a topic which no Catholic can afford to ignore."--Joseph Pearce, Aquinas College, Nashville, TN "The Case for Catholic Education speaks to the heart of the debate over whether Catholic education is 'worth it.'"--Sister John Mary Fleming, O.P., Executive Director for Catholic Education, USCCB "The Case for Catholic Education will surely play a vital role in reinvigorating the handing-on of essential Catholic truths."--Sister Joseph Andrew Bogdanowicz, O.P., Dominican Sisters of Mary, Mother of the Eucharist, Ann Arbor, MI "This short book contains an astonishing wealth of insights and practical suggestions."--Dr. Keith Cassidy, President of Our Lady Seat of Wisdom Academy "Ryan Topping has written an engaging and coherent analysis of the state of Catholic education in North America, which will be useful for teachers in Britain, too."--Dr. Paul Shrimpton, Magdalen College School, Oxford "An insightful view of our threatened patrimony and a framed vision for what educating and forming our children may still yet become."--Dr. Jason Fugikawa, Dean of Academics and Faculty, Holy Family Academy, Manchester, NH</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ryan N. S. Topping
      </h2>
      
      <p class="authorDescription body article">Ryan N. S. Topping earned a doctorate in theology from the University of Oxford and is a Fellow of Thomas More College of Liberal Arts, Merrimack, NH. He is the author of Happiness and Wisdom (CUA Press, 2012), Rebuilding Catholic Culture (Sophia Institute Press, 2013), and Renewing the Mind: A Reader in the Philosophy of Catholic Education (CUA Press, 2015).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Angelico Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13224186